export const SET_ERASMUS_CODE_ACTION = "SET_ERASMUS_CODE";
export const SET_AUTUMN_TERM_DEADLINE_ACTION = "SET_AUTUMN_TERM_DEADLINE";
export const SET_SPRING_TERM_DEADLINE_ACTION = "SET_SPRING_TERM_DEADLINE";
export const SET_COUNTRY_ACTION = "SET_COUNTRY";

export const SET_EXPAND_FILTERS_ACTION = "SET_EXPAND_FILTERS";
export const SET_SELECTED_FILTERS_LIST_ACTION = "SET_SELECTED_FILTERS_LIST";
export const SET_SORT_BY_ACTION = "SET_SORT_BY";
export const UPDATE_MULTIPLE_VALUES_ACTION = "UPDATE_MULTIPLE_VALUES_ACTION";


/**
 * Reducer for handling filter associated actions and state changes
 */
export const reducer = (state, action) => {
    return {
        ...state,
        ...action.payload,
    }
}